import * as omit from 'lodash/omit'
import { combineReducers } from 'redux'
import { Reducer } from 'interfaces'
import { NetworthDataState } from 'interfaces/networth'
import { Trend } from 'interfaces/trend'
import { createGenericTrendsReducer } from 'reducers/data/genericReducer'
import { createTimeframedState } from 'reducers/globalReducer'
import { Timeframe } from 'interfaces/chart'
import { GET_NETWORTH_SUMMARY, SET_MEMBER_NETWORTH_CHANGE } from 'actions/networthActions'
import { needDiscardData, NETWORTH_PAGE_DISCARD_TRIGGERS } from 'helpers/discardTriggerHelpers'
import { isSuccessAction } from 'helpers/actionsHelpers'
import { SET_RANDOM_RELATION } from 'actions/peergroupActions'

const networthPageDiscardTrigger = needDiscardData(NETWORTH_PAGE_DISCARD_TRIGGERS)

const createNetworthChangeReducer = (timeframe: Timeframe): Reducer<Trend | null> => (state = null, action) => {
  if (networthPageDiscardTrigger(action)) {
    return null
  }

  if (
    action.type === SET_MEMBER_NETWORTH_CHANGE &&
    action.payload.timeframe === timeframe
  ) {
    return action.payload.change
  }

  return state
}

const networthSummaryDataReducer: Reducer<NetworthDataState['summary']> = (state = null, action) => {
  if (networthPageDiscardTrigger(action)) {
    return null
  }

  if (action.type === SET_RANDOM_RELATION && state !== null) {
    // What's the magic here? Webpack is confused without the line below:
    const omitFromLoDash = omit
    return {
      ...state,
      peergroup_rank: omitFromLoDash(state.peergroup_rank, [action.payload.id]),
    }
  }

  if (action.type === GET_NETWORTH_SUMMARY && isSuccessAction(action)) {
    const { data } = action.payload.response

    if (!state) {
      return data
    }

    return {
      amount: data.amount,
      delta: {
        ...state.delta,
        ...data.delta,
      },
      peergroup_rank: {
        ...state.peergroup_rank,
        ...data.peergroup_rank,
      },
    }
  }

  return state
}

export default combineReducers<NetworthDataState>({
  summary: networthSummaryDataReducer,
  trends: createGenericTrendsReducer('networth'),
  change: createTimeframedState(createNetworthChangeReducer),
})
